import { BehaviorSubject, Observable } from 'rxjs';
import { IReportMetadata, ISubColumns } from './report-data.service';
import { IBrowseListConfig } from '../browselists/browselists-config.service';
import { IDescribedStringObject } from '../../../type_definitions/datatypes';
import { GridApi, GridOptions } from 'ag-grid-community';
import { IGADeferred } from '../services/ga-deferred.service';
import { GridSortType, ReportGridService } from './report-grid.service';

export interface IColumnSort {
  name:string;
  direction:GridSortType;
}

// For internal use only, external use only via ReportGridService
export class ReportGrid {
  private _rowCount:number = 0;
  private _rowCount$:BehaviorSubject<number> = new BehaviorSubject<number>(undefined);

  public reportMetaData:IReportMetadata;
  public subColumns:ISubColumns = {};
  public reportData:any[];
  public hasAggregates:boolean = false;
  public hasActions:boolean = false;
  public browseListConfig:IBrowseListConfig;
  public reportTitle:String;
  public autoSizeColumns:IDescribedStringObject = ReportGridService.SIZING_HEADER;
  public api:GridApi;

  public get rowCount():number {
    return this._rowCount;
  }

  public set rowCount(value:number) {
    this._rowCount = value;
    this._rowCount$.next(this._rowCount);
  }

  public get rowCountSubscriber():Observable<number> {
    return this._rowCount$.asObservable();
  }

  // in KPIs edit/delete methods are needed for each grid section (see embedded-report.component)
  public editRow?:Function;
  public deleteRow?:Function;

  public overlays:string[] = [];
  public reportReady:IGADeferred<GridApi>;

  // an array with column name and direction (asc or desc)
  public sortModel:IColumnSort[] = [];

  constructor(
    public gridOptions:GridOptions,
    public id:string
  ) {
    /**/
  }

}